<template>
 <input v-if="type != 'textarea'" :type="type" :name="theField" :id="theField" :value="getValue(theField)" @input="setValue(theField, $event.target.value)" @blur="setTouched(theField)" autocomplete="off" :maxlength="limit" :placeholder="placeholder">
 <textarea :id="theField" :value="getValue(theField)" @input="setValue(theField, $event.target.value)" @blur="setTouched(theField)" :placeholder="placeholder" v-else/>
</template>
<script lang="ts">
import { defineComponent, inject } from 'vue'
import type { Form } from '~/shared/form-types'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'text',
    },
    limit: {
      type: Number
    },
    placeholder: {
      type: String
    },
    field: String,
  },
  setup(props, context) {
    const { form, setValue, getValue, setTouched } = usePaymentForm()

    return {
      form,
      setValue,
      getValue,
      setTouched,
      theField: props.field || inject<keyof Form>('field', undefined),
    }
  },
})
</script>
<style scoped lang="scss">
input[type='text'],
input[type='number'],
input[type='email'],
input[type='password'],
input[type='tel'],
textarea {
  box-sizing: border-box;
  height: 44px;
  width: 100%;
  display: block;
  border: 1px solid #ddd;
  padding: 0 10px;
  border-radius: 4px;
  background: #f7f9fb;
  transition: all 0.3s ease-in-out;
  font-size: 16px;
  color: #222;

  &:hover {
    box-shadow: none;
    border-color: $color-blue;
  }

  &:focus {
    border-color: $color-blue;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    border: 1px solid #e4e4e4;
    background: #f3f2f2;
  }

  @media only screen and (min-width: 720px) {
    height: 42px;
  }
}
textarea {
  min-height: 64px;
}
input::-webkit-input-placeholder {
  color: #ccc;
}
input::-moz-placeholder {
  color: #ccc;
}
input:-ms-input-placeholder {
  color: #ccc;
}
</style>